<emm-management-layout>
  @if (true) {
    <emm-item-id-mappings-form #form layout-center-content
      [isSuperAdmin]="isSuperAdmin"
      [isAdmin]="isAdmin"
      (search)="itemIdMappingsForm.doSearch()"
      (upsert)="itemIdMappingsForm.doSubmit()"
    ></emm-item-id-mappings-form >
  }
</emm-management-layout>
